// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4aA8n","link":"styles_link__HMHuZ"};